<template>
    <div class="app-container">
        <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch"
                 label-width="80px">
            <el-form-item label="房型" prop="xingId">
                <el-select v-model="queryParams.xingId" @change="fangxingQ" filterable placeholder="请选择房型">
                    <el-option
                        v-for="item in fangxingList"
                        :key="item.id"
                        :label="item.fangName"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="房号" prop="jianId">
                <el-select v-model="queryParams.jianId" filterable placeholder="请选择房间">
                    <el-option
                        v-for="item in fangJianList"
                        :key="item.id"
                        :label="item.fangNo"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="客户来源" prop="keHu">
                <el-select v-model="queryParams.keHu" placeholder="请选择客户来源" filterable style="width: 300px">
                    <el-option
                        v-for="dict in dict.type.laiyuan"
                        :key="dict.value"
                        :label="dict.label"
                        :value="parseInt(dict.value)"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="状态" prop="fangStatus">
                <el-select v-model="queryParams.fangStatus" placeholder="请选择">
                    <el-option
                        v-for="item in fangStatusList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
                <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
            </el-form-item>
        </el-form>


        <el-row :gutter="10" class="mb8">
            <el-col :span="1.5">
                <el-button
                    type="primary"
                    icon="el-icon-plus"
                    size="mini"
                    @click="addFangInfo"
                >新增入住订单
                </el-button>
            </el-col>
        </el-row>

        <el-table v-loading="loading" :data="fangInfoList" @selection-change="handleSelectionChange">
            <!--      <el-table-column type="selection" width="55" align="center"/>-->
            <!--      <el-table-column label="${comment}" align="center" prop="id" />-->
            <el-table-column label="房型" align="center" prop="fangTypeName"/>
            <el-table-column label="入住人姓名" align="center" prop="name"/>
            <el-table-column label="入住人手机号" align="center" prop="phone"/>
            <el-table-column label="入住人身份证号" align="center" prop="idCard" width="180"/>
            <el-table-column label="合同开始日期" align="center" prop="heStartDate"/>
            <el-table-column label="合同截至日期" align="center" prop="heEndDate"/>
            <el-table-column label="入住日期" align="center" prop="startDate"/>
            <el-table-column label="截至日期" align="center" prop="endDate"/>
            <el-table-column label="入住月数" align="center" prop="month"/>
            <el-table-column label="房号" align="center" prop="fangNo"/>
            <el-table-column label="客户来源" align="center" prop="keHu">
                <template slot-scope="scope">
<!--                    <dict-tag :options="dict.type.laiyuan" :value="scope.row.keHu"/>-->
                    <label style="color: #F56C6C" v-if="scope.row.keHu===1">线上</label>
                    <label style="color: #409EFF" v-if="scope.row.keHu===2">线下</label>
                    <label style="color: #67C23A" v-if="scope.row.keHu===3">中介</label>
                    <label style="color: #E6A23C" v-if="scope.row.keHu===4">其他</label>
                </template>
            </el-table-column>
            <el-table-column label="合同电子版" align="center" prop="heTong">
                <template slot-scope="scope">
                    <el-link v-if="scope.row.heTong" :href="`${baseFileURL}${scope.row.heTong}`" :underline="false"
                             target="_blank">
                        <span class="el-icon-document"> 查看</span>
                    </el-link>
                </template>
            </el-table-column>
            <el-table-column label="状态" align="center" prop="status">
                <template slot-scope="scope">
                    <label style="color: #F56C6C" v-if="scope.row.status=='1'">待入住</label>
                    <label style="color: #409EFF" v-if="scope.row.status=='2'">已入住</label>
                    <label style="color: #67C23A" v-if="scope.row.status=='3'">已到期</label>
                    <label style="color: #E6A23C" v-if="scope.row.status=='4'">已结束</label>
                </template>
            </el-table-column>
            <!--      <el-table-column label="交易时间" align="center" prop="createTime"/>-->
            <el-table-column label="操作" align="center" class-name="small-padding fixed-width">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="text"
                        @click="handleUpdate(scope.row)"
                    >管理
                    </el-button>
                    <el-button
                        size="mini"
                        type="text"
                        v-if="scope.row.status!='4'"
                        @click="settlement(scope.row)"
                    >结算
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <pagination
            v-show="total>0"
            :total="total"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />

        <!-- 管理 -->
        <el-dialog :title="titleAdd" :visible.sync="openAdd" width="600px" append-to-body>
            <el-form ref="form" :model="dataAdd" label-width="130px">
                <el-form-item label="押金:">
                    <el-row>{{ dataAdd.deposit }}</el-row>
                </el-form-item>
                <el-form-item label="剩余水费:">
                    <el-row>{{ dataAdd.shuiFei }}</el-row>
                </el-form-item>
                <el-form-item label="剩余电费:">
                    <el-row>{{ dataAdd.dianFei }}</el-row>
                </el-form-item>
                <el-form-item label="应退款:">
                    <el-row>{{ dataAdd.yingTuiKuan }}</el-row>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitFormAdd()">确 定</el-button>
                <el-button @click="cancelAdd">取 消</el-button>
            </div>
        </el-dialog>

        <!-- 管理 -->
        <el-dialog :title="title" :visible.sync="open" width="600px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="130px">

                <el-form-item label="房型" prop="xingId">
                    <el-select v-model="form.xingId" @change="fangxing" filterable placeholder="请选择房型"
                               style="width: 300px">
                        <el-option
                            v-for="item in fangxingList"
                            :key="item.id"
                            :label="item.fangName"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="房号">
                    <el-select v-model="form.jianId" filterable placeholder="请选择房间" style="width: 300px">
                        <el-option
                            v-for="item in fangJianList"
                            :disabled="item.fangStatus != 1"
                            :key="item.id"
                            :label="item.fangNo"
                            :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="微信绑定手机号"  prop="phone">
                    <el-input v-model="form.phone" placeholder="请输入备注" style="width: 300px"/>
                </el-form-item>

                <el-form-item label="入住日期" prop="startDate">
                    <el-date-picker
                        style="width: 300px"
                        v-model="form.startDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="截至日期" prop="endDate">
                    <el-date-picker
                        style="width: 300px"
                        v-model="form.endDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="合同开始日期">
                    <el-date-picker
                        style="width: 300px"
                        v-model="form.heStartDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="合同到期日期">
                    <el-date-picker
                        style="width: 300px"
                        v-model="form.heEndDate"
                        type="date"
                        value-format="yyyy-MM-dd"
                        placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>

                <el-form-item label="客户来源">
                    <el-select v-model="form.keHu" placeholder="请选择客户来源" filterable style="width: 300px">
                        <el-option
                            v-for="dict in dict.type.laiyuan"
                            :key="dict.value"
                            :label="dict.label"
                            :value="parseInt(dict.value)"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="合同电子版">
<!--                    <file-upload v-model="form.heTong"/>-->
<!--                    <file-upload ref="uploader" namespace="FangInfo" @upload-success="handleUploadSuccess" />-->
                    <upload-file ref="uploader" namespace="FangInfo" @upload-success="handleUploadSuccess" />
                </el-form-item>
                <el-form-item label="初始水表数">
                    <el-input v-model="form.chuShui" placeholder="请输入初始水表数" style="width: 300px"/>
                </el-form-item>
                <el-form-item label="初始电表数">
                    <el-input v-model="form.chuDian" placeholder="请输入初始电表数" style="width: 300px"/>
                </el-form-item>
                <el-form-item label="押金" v-if="form.id==null">
                    <el-input v-model="form.deposit" placeholder="请输入押金" style="width: 300px"/>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="form.beiZhu" placeholder="请输入备注" style="width: 300px"/>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="form.fangStatus" filterable placeholder="请选择房间" style="width: 300px">
                        <el-option
                            v-for="item in fangStatusList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
    listAllFangxing,
    getFangJianByXingId,
    listFangInfo,
    getFangInfo,
    delFangInfo,
    addFangInfo,
    updateFangInfo,
    refund,
    jiesuan
} from "@/api/homestay/api";
// import FileUpload from '@/components/upload/FileUpload'
import UploadFile from '@/components/upload/uploadFile'
export default {
    name: "FangInfo",
    components: { UploadFile },
    dicts: ['laiyuan'],
    data() {
        return {
            // 根路径
            baseURL: process.env.VUE_APP_BASE_API,
            baseFileURL: 'https://xinlewuye.oss-cn-beijing.aliyuncs.com/hc/',
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            // 入住订单表格数据
            fangInfoList: [],
            fangJianList: [],
            fangStatusList: [
                {
                    value: 1,
                    label: '待入住'
                }, {
                    value: 2,
                    label: '已入住'
                }, {
                    value: 3,
                    label: '已到期'
                }, {
                    value: 4,
                    label: '已结束'
                }
            ],
            dict: {
                type: {
                    laiyuan: [
                        {
                            value: 1,
                            label: '线上'
                        }, {
                            value: 2,
                            label: '线下'
                        }, {
                            value: 3,
                            label: '中介'
                        }, {
                            value: 4,
                            label: '其他'
                        }
                    ]
                }
            },
            fangxingList: [],
            // 弹出层标题
            title: "",
            titleAdd: "",
            // 是否显示弹出层
            open: false,
            openAdd: false,
            // 查询参数
            queryParams: {
                pageNum: 1,
                pageSize: 10,
                xingId: null,
                openId: null,
                startDate: null,
                keHu: null,
                month: null,
                jianId: null,
                fangStatus: null,
            },
            dataAdd: [],
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                id: [
                    {required: true, message: "$comment不能为空", trigger: "blur"}
                ],
                xingId: [
                    {required: true, message: "房型id不能为空", trigger: "blur"}
                ],
                openId: [
                    {required: true, message: "openid不能为空", trigger: "blur"}
                ],
                startDate: [
                    {required: true, message: "入住日期不能为空", trigger: "blur"}
                ],
                endDate: [
                    {required: true, message: "截至日期不能为空", trigger: "blur"}
                ],
                phone: [
                    {required: true, message: "手机不能为空", trigger: "blur"}
                ],
                month: [
                    {required: true, message: "入住月数不能为空", trigger: "blur"}
                ],
                fangNo: [
                    {required: true, message: "房号不能为空", trigger: "blur"}
                ],
                fangStatus: [
                    {required: true, message: "状态不能为空", trigger: "blur"}
                ],
                delFlag: [
                    {required: true, message: "删除标志不能为空", trigger: "blur"}
                ],
            },
            //结算id
            jieSuanId: null,
        };
    },
    created() {
        this.getList();
        listAllFangxing().then(res => {
            this.fangxingList = res.data;
        });
    },
    methods: {
        fangxing() {
            //根据房型id查询剩余房间
            getFangJianByXingId({'xingId':this.form.xingId}).then(res => {
                this.fangJianList = res.data;
                this.form.jianId = null;
            })
        },
        fangxingQ() {
            //根据房型id查询剩余房间
            getFangJianByXingId({'xingId':this.queryParams.xingId}).then(res => {
                this.fangJianList = res.data;
                this.queryParams.jianId = null;
            })
        },
        /** 查询入住订单列表 */
        getList() {
            this.loading = true;
            listFangInfo(this.queryParams).then(response => {
                this.fangInfoList = response.data;
                this.total = response.total;
                this.loading = false;
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 取消按钮
        cancelAdd() {
            this.openAdd = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                id: null,
                xingId: null,
                openId: null,
                startDate: null,
                endDate: null,
                heStartDate: null,
                heEndDate: null,
                month: null,
                jianId: null,
                keHu: null,
                heTong: null,
                beiZhu: null,
                fangStatus: 1,
                delFlag: null,
                chuShui: null,
                chuDian: null,
                deposit: null,
            };
            if (this.$refs.uploader) {
                this.$refs.uploader.clear()
            }
            this.resetForm("form");
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm("queryForm");
            this.handleQuery();
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id)
            this.single = selection.length !== 1
            this.multiple = !selection.length
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = "添加入住订单";
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            const ids = row.id || this.ids.join(',')
            getFangInfo({'id':ids}).then(response => {
                this.form = response.data;
                this.open = true;
                this.title = "管理";
                this.fangxing()
            });
        },
        // 结算
        settlement(row) {
            refund({'id':row.id}).then(res => {
                this.jieSuanId = row.id;
                this.openAdd = true;
                this.titleAdd = "结算";
                this.dataAdd = res.data;
            })
        },
        addFangInfo() {
            this.reset();
            this.open = true;
            this.title = "新增入住订单";
        },
        submitFormAdd() {
            jiesuan({'id':this.jieSuanId}).then(() => {
                this.$modal.msgSuccess("结算完成");
                this.openAdd = false;
                this.getList();
            })
        },
        /** 提交按钮 */
        submitForm() {
            this.$refs["form"].validate(valid => {
                if (valid) {
                    if (this.form.id != null) {
                        updateFangInfo(this.form).then(() => {
                            this.$modal.msgSuccess("修改成功");
                            this.open = false;
                            this.getList();
                        });
                    } else {
                        addFangInfo(this.form).then(() => {
                            this.$modal.msgSuccess("新增成功");
                            this.open = false;
                            this.getList();
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            const idss = row.id || this.ids.join(',');
            this.$modal.confirm('是否确认删除入住订单编号为"' + idss + '"的数据项？').then(function () {
                return delFangInfo({'ids': idss});
            }).then(() => {
                this.getList();
                this.$modal.msgSuccess("删除成功");
            }).catch(() => {
            });
        },
        handleUploadSuccess(file) {
            this.form.heTong = file.realFileName
        },
    }
};
</script>
